import { z } from 'zod';
import { templateConditionV1Schema } from './condition';

export const ADVANCE_TEXT_COLOR = {
  RED: 'RED',
  YELLOW: 'YELLOW',
  BLUE: 'BLUE',
} as const;

export const ADVANCE_ALERT_TYPE = {
  INFO: 'INFO',
  WARN: 'WARN',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
} as const;

export const ADVANCE_REMINDER_METHOD = {
  TEXT: 'TEXT',
  ALERT: 'ALERT',
} as const;

export const ADVANCE_EVENT_NAME = {
  SET_REQUIRED: 'SET_REQUIRED',
  SET_DISABLED: 'SET_DISABLED',
  SET_NOT_EQUAL_TO: 'SET_NOT_EQUAL_TO',
  SET_DEFAULT: 'SET_DEFAULT',
} as const;

const eventSchema = z.union([
  z.object({
    fieldId: z.string().min(1),
    eventName: z.enum([
      ADVANCE_EVENT_NAME.SET_REQUIRED,
      ADVANCE_EVENT_NAME.SET_DISABLED,
    ]),
    value: z.undefined().optional(),
  }),
  z.object({
    fieldId: z.string().min(1),
    eventName: z.enum([
      ADVANCE_EVENT_NAME.SET_NOT_EQUAL_TO,
      ADVANCE_EVENT_NAME.SET_DEFAULT,
    ]),
    value: z.string().min(1),
  }),
]);

export type EventSchema = z.infer<typeof eventSchema>;

const reminderSchema = z.union([
  z.object({
    method: z.literal(ADVANCE_REMINDER_METHOD.TEXT),
    color: z.enum(Object.values(ADVANCE_TEXT_COLOR)),
    content: z.string().min(1),
  }),
  z.object({
    method: z.literal(ADVANCE_REMINDER_METHOD.ALERT),
    type: z.enum(Object.values(ADVANCE_ALERT_TYPE)),
    content: z.string().min(1),
  }),
]);

export type ReminderSchema = z.infer<typeof reminderSchema>;

export type ReminderText = Extract<
  ReminderSchema,
  { method: typeof ADVANCE_REMINDER_METHOD.TEXT }
>;

export type ReminderAlert = Extract<
  ReminderSchema,
  { method: typeof ADVANCE_REMINDER_METHOD.ALERT }
>;

export type ReminderAlertItem = ReminderAlert & { id: string };

export type OwnerReminders = {
  texts: ReminderText[];
  alerts: ReminderAlertItem[];
};

export const templateAdvanceLogicV1Schema = z.array(
  z.object({
    label: z.string(),
    conditions: z.array(templateConditionV1Schema),
    events: z.array(eventSchema),
    reminders: z.array(reminderSchema),
  }),
);

export type TemplateAdvanceLogicV1Schema = z.infer<
  typeof templateAdvanceLogicV1Schema
>;
